<template>
  <div>
    <h2 class="text-3xl font-bold mb-6 text-center text-gray-800">
      {{ property.title || t('property_detail.property.title') }}
    </h2>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-700">
      <div class="col-span-2">
        <span class="font-semibold">{{ t('property_detail.property.description') }}</span>
        <div v-html="property.description"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  property: Object
})
</script>
